import { Outlet } from "react-router-dom";

import { AccountingGrid } from "../components/AccountingGrid";

/**
 * Accounting List Page component for the main accounting navigation tab.
 * Displays milestones grouped by brand and campaign for financial tracking.
 */
export function AccountingListPage() {
  return (
    <section className="accounting-list-page main-page">
      <div className="main-page__content">
        <div className="main-page__header">
          <h1>Accounting Dashboard</h1>
        </div>
        <div className="main-page__body">
          <AccountingGrid />
        </div>
      </div>
      <Outlet />
    </section>
  );
}
